/*
*  new_map
*
*  This function will render a Google Map onto the selected jQuery element
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$el (jQuery element)
*  @return	n/a
*/

function new_map($el) {
    //var zoom = parseInt($el.attr('data-zoom'));
    //var zoom = 10;
    var zoom = 15;

    var $markers = $el.find('.marker');

    var args = {
        zoom: zoom,
        zoomControlOptions: {
            position: google.maps.ControlPosition.LEFT_TOP
        },    
        center: {lat: 0, lng: 0},
        scaleControl: false,
        scrollwheel: false,
        navigationControl: false,
        streetViewControl: false,			
        mapTypeControl: false
    };

    var mapStyles = [
  {
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "elementType": "labels.icon",
    "stylers": [
      {
        "visibility": "off"
      }
    ]
  },
  {
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "elementType": "labels.text.stroke",
    "stylers": [
      {
        "color": "#f5f5f5"
      }
    ]
  },
  {
    "featureType": "administrative.land_parcel",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#bdbdbd"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "poi",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "poi.park",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "road",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#ffffff"
      }
    ]
  },
  {
    "featureType": "road.arterial",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#757575"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#dadada"
      }
    ]
  },
  {
    "featureType": "road.highway",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#616161"
      }
    ]
  },
  {
    "featureType": "road.local",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  },
  {
    "featureType": "transit.line",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#e5e5e5"
      }
    ]
  },
  {
    "featureType": "transit.station",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#eeeeee"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "geometry",
    "stylers": [
      {
        "color": "#c9c9c9"
      }
    ]
  },
  {
    "featureType": "water",
    "elementType": "labels.text.fill",
    "stylers": [
      {
        "color": "#9e9e9e"
      }
    ]
  }
];
        	
    var map = new google.maps.Map($el[0], args);
    map.setOptions({
        styles: mapStyles
    });
    
    map.markers = [];
    $markers.each(function() {
        add_marker($(this), map);
    });

    center_map(map, zoom);
    $(window).resize(function () {
        center_map(map, zoom);
    });

    return map;
}

/*
*  add_marker
*
*  This function will add a marker to the selected Google Map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	$marker (jQuery element)
*  @param	map (Google Map object)
*  @return	n/a
*/

function add_marker($marker, map) {
	var latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
	var markerIcon = $marker.attr('data-marker-icon');
	var title = $marker.find('h4').text();

	var marker = new google.maps.Marker({
		position: latlng,
		map: map,
		draggable: false,
		animation: google.maps.Animation.DROP,
		title: title,
		icon: new google.maps.MarkerImage(
			'/fileadmin/template/marker/' + markerIcon + '.png',
			new google.maps.Size(43, 58),
			new google.maps.Point(0, 0),
			new google.maps.Point(21, 58)
        ),
	});

	map.markers.push(marker);

	if($marker.html().trim()) {
		var infowindow = new google.maps.InfoWindow({
			content: $marker.html()
		});

		google.maps.event.addListener(marker, 'click', function() {
			infowindow.open(map, marker);
		});
	}
}

/*
*  center_map
*
*  This function will center the map, showing all markers attached to this map
*
*  @type	function
*  @date	8/11/2013
*  @since	4.3.0
*
*  @param	map (Google Map object)
*  @return	n/a
*/

function center_map(map, zoom) {
	var bounds = new google.maps.LatLngBounds();

	$.each( map.markers, function(i, marker) {
		var latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
		bounds.extend(latlng);
	});

	if(map.markers.length == 1) {
	    map.setCenter(bounds.getCenter());
	    map.setZoom(zoom);
	} else {
        map.fitBounds(bounds);
	}

}

var map = null;
$('.google-map').each(function() {
    map = new_map($(this));
});


// WEBPACK FOOTER //
// ./js/contentelements/googlemaps.js